export default {
    EdicaoRapida: axios.create({
        baseURL: process.env.VUE_APP_ENDPOINT_API + "edicao-rapida"
    })
}


//////////////////
// WEBPACK FOOTER
// ../core/resources/routes/EdicaoRapida.js
// module id = Ohvm
// module chunks = 13